import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerBillableItemLine } from "../_types/worker-billable-item-line";

@Injectable({
    providedIn: 'root',
})
export class WorkerBillableItemLinesService extends Service<WorkerBillableItemLine> {
    public override type = 'workerBillableItemLines';
    public override url = 'invoicing/workerBillableItemLines';

    generate(startDate: Date, endDate: Date, workerId?: string, workerBillableItemTypeId?: string,workerBillableItemId?:string, forceRecalculationDistance: boolean = false) {
        let url = this.getAPIUrl() + '/generate';
        let params: any = {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            forceRecalculationDistance: forceRecalculationDistance
        };
        if (workerId) {
            params.workerId = workerId;
        }
        if (workerBillableItemTypeId) {
            params.workerBillableItemTypeId = workerBillableItemTypeId;
        }
        if (workerBillableItemId) {
            params.workerBillableItemId = workerBillableItemId;
        }
        return this.http.get<WorkerBillableItemLine[]>(url, { params });
    }

    saveItems(items: WorkerBillableItemLine[]) {
        let url = this.getAPIUrl() + '/saveItems';
        return this.http.post(url, items);
    }
}
